import styled from "styled-components";

export const ItalicHeader = styled.h5`
  font-style: italic;
`;
